import React from 'react';

import PropTypes, { any } from 'prop-types';
import UtrLogo from '../MatchScorePrintPage/UtrLogo';

import styles from './medalReportPrintPage.scss';
import Img from '../../components/Img';

const MedalReport = ({ eventName, drawName, drawDate, drawWinners, otherDrawWinners, message }) => {
    const Header = () => {
        return (
            <div className={styles.header} data-testid="medal-report.header">
                <div className={styles.headerLeft}>
                    <div className={`${styles.line}`}>
                        <div className={styles.textWrapper} data-testid="medal-report.header.event-name-label">EVENT NAME</div>
                        <div className={styles.textWrapper2} data-testid="medal-report.header.event-name">{eventName}</div>
                    </div>
                    <div className={`${styles.line} ${styles.bt}`}>
                        <div className={styles.textWrapper} data-testid="medal-report.header.draw-name-label">DRAW NAME</div>
                        <div className={styles.textWrapper2} data-testid="medal-report.header.draw-name">{drawName}</div>
                    </div>
                </div>
                <div className={styles.headerRight}>
                    <div className={styles.textWrapper} data-testid="medal-report.header.date-label">DATE</div>
                    <p className={styles.textWrapper2} data-testid="medal-report.header.date">{drawDate}</p>
                </div>
            </div>
        );
    };
    const WinnerCard = ({ drawMedal, name, divisionName, divisionMedal, player2, dataTestId }) => {
        return (
            <div className={styles.playerCard}>
                <div className={styles.medal}>
                    {!!drawMedal && <Img src={`/img/medals/${drawMedal}.svg`} style={{ width: '40px' }} data-testid={`${dataTestId}.medal-img`} />}
                </div>
                <div className={styles.detailsWrapper}>
                    <div className={styles.playerDetails}>
                        <div className={styles.name} data-testid={`${dataTestId}.name`}>{name}</div>
                        <div className={styles.division} data-testid={`${dataTestId}.division`}>
                            {!!divisionMedal && <Img src={`/img/medals/${divisionMedal}.svg`} style={{ width: '20px' }} />}
                            {divisionName}
                        </div>
                    </div>
                    {player2 && (
                        <div className={`${styles.playerDetails} mt8`}>
                            <div className={styles.name} data-testid={`${dataTestId}.partner-name`}>{player2.winnerName}</div>
                            <div className={styles.division} data-testid={`${dataTestId}.partner-division`}>
                                {!!player2.divisionMedal && <Img src={`/img/medals/${player2.divisionMedal}.svg`} style={{ width: '20px' }} />}
                                {player2.divisionName}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    };
    const WinnerCardSmall = ({ name, divisionName, divisionMedal, player2, dataTestId }) => {
        return (
            <div className={styles.playerCardSmall}>
                <div className={styles.detailsWrapper}>
                    <div className={styles.playerDetails}>
                        <div className={styles.name} data-testid={`${dataTestId}.name`}>{name}</div>
                        <div className={styles.division} data-testid={`${dataTestId}.division`}>
                            {!!divisionMedal && <Img src={`/img/medals/${divisionMedal}.svg`} style={{ width: '20px' }} data-testid={`${dataTestId}.medal-img`} />}
                            {divisionName}
                        </div>
                    </div>
                    {player2 && (
                        <div className={`${styles.playerDetails} mt8`}>
                            <div className={styles.name} data-testid={`${dataTestId}.partner-name`}>{player2.winnerName}</div>
                            <div className={styles.division} data-testid={`${dataTestId}.partner-division`}>
                                {!!player2.divisionMedal && <Img src={`/img/medals/${player2.divisionMedal}.svg`} style={{ width: '20px' }} />}
                                {player2.divisionName}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    };
    return (
        <div className={styles.medalReport} data-testid="medal-report.container">
            <UtrLogo style={{ marginTop: '14px' }} />
            <div className={`mt24`}>
                <Header />
                {message && <div className={styles.message} data-testid="medal-report.message">{message}</div>}
                {drawWinners && drawWinners.length > 0 && (
                    <div>
                        <div className={`${styles.textWrapper} mt24`} data-testid="medal-report.draw-winners-heading">
                            DRAW MEDAL WINNERS
                        </div>
                        <div className={`${styles.bt}`}>
                            {drawWinners.map((winner, i) => (
                                <WinnerCard
                                    key={i}
                                    name={winner.winnerName}
                                    drawMedal={winner.drawMedal}
                                    divisionName={winner.divisionName}
                                    divisionMedal={winner.divisionMedal}
                                    player2={winner.player2}
                                    dataTestId={`medal-report.draw-winner-${i}`}
                                />
                            ))}
                        </div>
                    </div>
                )}
                {otherDrawWinners && otherDrawWinners.length > 0 && (
                    <div>
                        <div className={`${styles.textWrapper} mt24`} data-testid="medal-report.other-winners-heading">
                            OTHER MEDAL WINNERS
                        </div>
                        <div className={`${styles.twoColumn}`}>
                            {otherDrawWinners.map((winner, i) => (
                                <WinnerCardSmall
                                    key={i}
                                    name={winner.winnerName}
                                    drawMedal={winner.drawMedal}
                                    divisionName={winner.divisionName}
                                    divisionMedal={winner.divisionMedal}
                                    player2={winner.player2}
                                    dataTestId={`medal-report.other-winner-${i}`}
                                />
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

MedalReport.propTypes = {
    eventName: PropTypes.string,
    drawName: PropTypes.string,
    drawDate: PropTypes.string,
    drawWinners: PropTypes.objectOf(any),
    otherDrawWinners: PropTypes.objectOf(any),
    message: PropTypes.string,
};

MedalReport.defaultProps = {
    eventName: '',
    drawName: '',
    drawDate: '',
    drawWinners: [],
    otherDrawWinners: [],
    message: '',
};

export default MedalReport;
